import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ListAltIcon from '@mui/icons-material/ListAlt';
import TableChartIcon from '@mui/icons-material/TableChart';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import './Sidebar.css';
import Logo from '../assets/LWPL_White_Logo.png';

const Sidebar = () => {
  const [hover, setHover] = useState(false);
  const [openLogoutDialog, setOpenLogoutDialog] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    { label: 'Dashboard', icon: <DashboardIcon />, path: '/dashboard' },
    { label: 'Entries', icon: <AssignmentIcon />, path: '/form' },
    { label: 'Policies', icon: <ListAltIcon />, path: '/view-all' },
    { label: 'Master Data', icon: <TableChartIcon />, path: '/data' },
    { label: 'Logout', icon: <ExitToAppIcon />, path: '/' },
  ];

  const handleLogoutClick = (e) => {
    e.preventDefault(); // Prevent default Link navigation
    setOpenLogoutDialog(true);
  };

  const handleLogoutConfirm = () => {
    setOpenLogoutDialog(false);
    navigate('/');
  };

  const handleLogoutCancel = () => {
    setOpenLogoutDialog(false);
  };

  return (
    <div
      className={`sidebar ${hover ? 'expanded' : 'collapsed'}`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div className="logo-section">
        <img
          src={Logo}
          alt="Logo"
          className={`sidebar-logo ${hover ? 'expanded-logo' : 'collapsed-logo'}`}
        />
      </div>
      <ul>
        {menuItems.map((item, index) => (
          <li key={index} className={location.pathname === item.path ? 'active' : ''}>
            <Tooltip title={!hover ? item.label : ''} placement="right">
              <Link
                to={item.path}
                onClick={item.label === 'Logout' ? handleLogoutClick : undefined}
                style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: hover ? 'flex-start' : 'center', paddingLeft: hover ? '20px' : '0' }}
              >
                {item.icon}
                {hover && <span className="menu-text">{item.label}</span>}
              </Link>
            </Tooltip>
          </li>
        ))}
      </ul>

      <Dialog
        open={openLogoutDialog}
        onClose={handleLogoutCancel}
        aria-labelledby="logout-dialog-title"
        PaperProps={{
          sx: {
            bgcolor: '#121212',
            color: '#fff',
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle id="logout-dialog-title">
          <Typography variant="h6" fontWeight={600}>
            Confirm Logout
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Are you sure you want to logout?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleLogoutCancel}
            sx={{
              color: '#fff',
              borderColor: '#fff',
              '&:hover': { borderColor: '#fff', backgroundColor: 'rgba(255,255,255,0.1)' },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleLogoutConfirm}
            sx={{
              color: '#e0b256',
              borderColor: '#e0b256',
              '&:hover': { borderColor: '#e0b256', backgroundColor: 'rgba(224,178,86,0.1)' },
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Sidebar;